import React, { useEffect, useState } from "react";
import VerificationCodeForm from "../components/VerificationInput";
import StylePack from "../../../util/StylePack.js";
import styles from "./VerifyEmail.module.css";
import TitleText, { TitleTextSize } from "../../../components/TitleText";
import Paragraph from "../../../components/Paragraph";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import TwoColLayout from "../../Templates/TwoColLayout";
import { useTranslation } from "react-i18next";
import MainTemplate from "../../Templates/MainTemplate";
import { PinInputState } from "../../../components/PinInput";
import { useAppDispatch } from "../../../store/hooks";
import {
  sendVerifyCode,
  verifyEmailCode,
} from "../../../store/on-boarding-slice";
import { showConsoleError } from "../../../util/ConsoleMessage";
import { SendVerifyCodeAction } from "../../../api/models/SendVerifyCodeAction";
import { ContactType } from "../../../api/models/ContactType";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [pinInputState, setPinInputState] = useState(PinInputState.default);
  const dispatch = useAppDispatch();
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const handleContinue = async (pin: string) => {
    setErrorMessage(undefined);
    try {
      await dispatch(verifyEmailCode(pin));
      navigate("/verify_number");
    } catch (error: any) {
      showConsoleError(error);
      setErrorMessage(error.data.error);
      setPinInputState(PinInputState.error);
    }
  };

  useEffect(() => {
    if (pinInputState != PinInputState.error) {
      setErrorMessage(undefined);
    }
  }, [pinInputState]);

  const handleCancel = () => {
    navigate(-1);
  };

  const emailValue = useSelector((state: RootState) => state.onBoarding.email);

  const resendCode = async () => {
    try {
      await dispatch(
        sendVerifyCode(
          SendVerifyCodeAction.emailVerification,
          ContactType.email,
          emailValue
        )
      );
    } catch (error: any) {
      showConsoleError(error);
      setErrorMessage(error.errorObj.data.error);
      setPinInputState(PinInputState.error);
    }
  };

  const leftContent = (
    <VerificationCodeForm
      onCancel={handleCancel}
      onSubmit={handleContinue}
      onResend={resendCode}
      pinInputState={pinInputState}
      setPinInputState={setPinInputState}
      titleComponent={
        <TitleText size={TitleTextSize.heading3}>
          {t("verify_email.title")}
        </TitleText>
      }
      descriptionComponent={
        <Paragraph>
          {t("verify_email.description")}
          <br />
          <strong className={styles["emailHighlight"]}>{emailValue}</strong>
        </Paragraph>
      }
      errorMessage={errorMessage}
    />
  );
  const body = <TwoColLayout leftContent={leftContent} />;

  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      hasOverlayFooter
      backgroundStyle={StylePack.BACKGROUND_LOGIN_STYLE}
    />
  );
};

export default VerifyEmail;
